<template>
<div class="chapter">
<div class="inner_page">
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9781440506963_epub_cov.vue?22e8fa30